<template>
    <div>
        <Modal v-model="isShowModal" :title="title" @on-cancel="hide()" :mask-closable="false" width="950">

            <Divider orientation="left">订单信息</Divider>
          <Row :gutter="16">
            <Col span="8">
              <div>订单编号：{{ orderInfo.recoveryOrder.orderCode }}</div>
            </Col>
            <Col span="8">
              <div>订单标题：{{ orderInfo.recoveryOrder.orderTitle }}</div>
            </Col>
            <Col span="8">
            </Col>
            <Col span="8">
              <div>下单昵称：{{ orderInfo.recoveryOrder.nickName }}</div>
            </Col>
          </Row>
          <Row :gutter="16">
            <Col span="8">
              <div>创建时间：{{ orderInfo.recoveryOrder.createTime }}</div>
            </Col>
            <Col span="8">
              <div>取消时间：{{ orderInfo.recoveryOrder.cancelTime ?  orderInfo.recoveryOrder.cancelTime : '-'}}</div>
            </Col>
            <Col span="8">
              <div>
                订单状态：
                <template v-if="orderInfo.recoveryOrder.orderState == 1">待确认</template>
                <template v-if="orderInfo.recoveryOrder.orderState == 2">待回收</template>
                <template v-if="orderInfo.recoveryOrder.orderState == 3">运输中</template>
                <template v-if="orderInfo.recoveryOrder.orderState == 4">待验收</template>
                <template v-if="orderInfo.recoveryOrder.orderState == 5">已完成</template>
                <template v-if="orderInfo.recoveryOrder.orderState == 6">已取消</template>
                <template v-if="orderInfo.recoveryOrder.orderState == 7">揽件失败</template>
              </div>
            </Col>
          </Row>
          <Row :gutter="16">
            <Col span="8">
              <div>
                预估重量：{{
                  orderInfo.recoveryOrder.estimateWeight ? orderInfo.recoveryOrder.estimateWeight : '-'
                }}
              </div>
            </Col>
            <Col span="8">
              <div>
                订单备注：{{
                  orderInfo.recoveryOrder.remark ? orderInfo.recoveryOrder.remark : '-'
                }}
              </div>
            </Col>
          </Row>
          <Row :gutter="16">
            <Col span="8">
              <div>用户上传图片：
                <div class="" style="margin-right: 10px"  v-for="(v,i) in formatImage(orderInfo.recoveryOrder.userImg)"
                     :key="i" @click="previewImage(formatImage(orderInfo.recoveryOrder.userImg))">
                  <img :src="v" style="width: 100px; height: 100px;">
                </div>
              </div>
            </Col>
          </Row>
          <Divider orientation="left">回收地址</Divider>
          <Row :gutter="16">
            <Col span="8">
              <div >用户姓名：{{ orderInfo.address.realName }}</div>
            </Col>
            <Col span="8">
              <div>用户手机号：{{ orderInfo.address && orderInfo.address.mobile ? orderInfo.address.mobile : '-' }}</div>
            </Col>
          </Row>

          <Row>
            <Col span="24">
              <div>用户地址：<span style="color: #2baee9;cursor:pointer" @click="showOrderInfoMap">{{ orderInfo.address && orderInfo.address.locationAddress }} {{ orderInfo.address && orderInfo.address.address }}</span></div>
            </Col>
          </Row>


            <Divider orientation="left">进行派单</Divider>
            <Row :gutter="16">
              <Col span="8">
                <div>
                  快递公司：
                  <Select v-model="expressType" style="width:200px">
                    <Option v-for="(item, index) in expressList" :value="item.value" :key="index">{{ item.label }}</Option>
                  </Select>
                </div>
              </Col>
              <Col span="8">
                <div>
                  送达仓库：
                  <Select v-model="deliveryAddressId" style="width:200px">
                    <Option v-for="(item, index) in warehouseList" :value="item.value" :key="index">{{ item.label }}</Option>
                  </Select>
                </div>
              </Col>
            </Row>
          <!-- 图片预览弹窗 -->
          <viewer :images="images" class="viewer" ref="viewer" @inited="inited" v-show="showImage">
            <template scope="scope">
              <img v-for="src in scope.images" :src="src+`?${Date.now}`" :key="src">
              {{ scope.options }}
            </template>
          </viewer>
            <!-- 重写对话框底部按钮 -->
            <div slot="footer">
                <Button @click="hide('formValidate')">取消</Button>
                <Button type="primary" @click="dispatchOrder()" :loading="loadingBtn">
                    <span v-if="!loadingBtn">保存</span>
                    <span v-else>请稍候...</span>
                </Button>
            </div>
        </Modal>
      <order-info-map ref="orderInfoMap"></order-info-map>
    </div>
</template>

<script>
import orderInfoMap from "./order-info-map.vue";

export default {
    data() {
        return {
            isShowModal: false,
            loadingBtn: false,
            orderInfo: {
                recoveryOrder: {},
                address: {},
                recoveryOrderItem: []
            },
            title: '派单',
            images: [],
            showImage: false,
            warehouseList: [],
            expressList: [
              {
                value: 1,
                label: '德邦快递',
              },
              {
                value: 2,
                label: '京东快递',
              },
              {
                value: 3,
                label: '顺丰快递',
              }
            ],
            deliveryAddressId: '',
            recoveryOrderId: '',
            expressType: '',
            params: {
              page: 1,
              rows: 20,
              isDisable: 0,
            },
          type: ''
        }
    },
    methods: {
        // 显示模态框
        show(type, row) {
            this.findList();
            this.isShowModal = true;
            this.type = type;
            this.getInfo(row);
          /**
           * type判断
           * 1.查看 2.新增 3.编辑
           */
          switch (type) {
            case 1:
              this.title = '派单';
              break;
            case 2:
              this.title = '修改仓库';
              break;
            default:
              this.$Notice.error({
                title: '订单管理',
                desc: '查看，新增，编辑模态框报错',
                duration: 0
              });
              break
          }

        },
        // 查询订单详情
        getInfo(row) {
            this.$Spin.show();
            this.axios.post('/recoveryOrder/getInfo', {
                recoveryOrderId: row.recoveryOrderId
            }).then(res => {
                console.log(res);
                this.recoveryOrderId = row.recoveryOrderId
                setTimeout(() => {
                    this.$Spin.hide();
                }, 300);
                if (res.status == 200) {
                    // this.$Message.success('操作成功.');
                    this.orderInfo = res.data;
                }
                if (res.status == 500) {
                    this.$Notice.error({
                        title: '服务器内部错误',
                        desc: '查看订单详情接口报错',
                        duration: 0
                    });
                }
            })
        },
        // 关闭模态框
        hide() {
            this.isShowModal = false;
        },
        // 保存派单
        dispatchOrder() {
          if (this.type === 1) {
            this.axios.post('/recoveryOrder/dispatchOrder', {'expressType': this.expressType, 'recoveryOrderId': this.recoveryOrderId, 'deliveryAddressId': this.deliveryAddressId}).then(res => {
              if (res.status == 200) {
                this.$emit('changeDate');
                this.$Message.success('操作成功.');
                this.hide('formValidate');
              }
              if(res.status == 201){
                this.$Message.error(res.msg);
              }
              if (res.status == 500) {
                this.$Notice.error({
                  title: '服务器内部错误',
                  desc: '派单接口报错',
                  duration: 0
                });
              }
            })
          } else if (this.type === 2) {

            this.axios.post('/recoveryOrder/updateDeliveryWarehouse', {'recoveryOrderId': this.recoveryOrderId, 'deliveryAddressId': this.deliveryAddressId}).then(res => {
              if (res.status == 200) {
                this.$emit('changeDate');
                this.$Message.success('操作成功.');
                this.hide('formValidate');
              }
              if(res.status == 201){
                this.$Message.error(res.msg);
              }
              if (res.status == 500) {
                this.$Notice.error({
                  title: '服务器内部错误',
                  desc: '修改仓库接口报错',
                  duration: 0
                });
              }
            })
          }

        },
        // 回收仓库-列表查询
        findList() {
          this.axios.post('/warehouse/findList', this.params).then(res => {
            if (res.status == 200) {
              this.total = res.data.total;
              this.data = res.data.rows;
              if (this.data) {
                this.warehouseList = []
                this.data.forEach(v => {
                  let object = {
                    value: v.warehouseId,
                    label: v.warehouseName
                  }
                  this.warehouseList.push(object)
                })
              }
            }
            if (res.status == 500) {
              this.$Notice.error({
                title: '服务器内部错误',
                desc: '查询回收员列表接口报错',
                duration: 0
              });
            }
          })
        },
      showOrderInfoMap() {
        this.$refs.orderInfoMap.show(this.orderInfo);
      },
      inited(viewer) {
        this.$viewer = viewer
      },
      previewImage(images) {
        this.images = images;
        this.$viewer.show();
      },
      // 格式化图片
      formatImage(image) {
        if (image) {
          return image.split(',')
        }
      },
    },
  components: {
    orderInfoMap
  }
}
</script>

<style scoped lang="less">
.j-order-image {
    display: flex;

    .j-order-image-main {
        width: 100px;
        height: 100px;

        img {
            width: 100%;
            height: 100%;
        }
    }

    .j-order-image-info {
        margin-left: 10px;

        .j-order-goods-sku {
            margin-top: 5px;
        }

        .j-order-goods-price {
            margin-top: 5px;
        }

        .j-order-goods-num {
            margin-top: 5px;
        }
    }
}

</style>